export const STATUS_NOTE_CANCELLED = "Cancelada";
export const STATUS_NOTE_SENT = "Emitida";
